import { Loading } from ".";
import { textChooser } from "../../util/textChooser";
import "./loadingPage.scss";

interface LoadingPageProps{
    titlePage?: string;
    titleDesc?: string;
}

export const LoadingPage = (props: LoadingPageProps) => {
    return (
        <div className="loading-page-wrapper">
            <div className="loading-page-inner">
                <Loading/>
                <h3 className="loading-page-title">
                    {textChooser("txt159")}
                </h3>
                <p className="loading-page-desc">
                    {textChooser("txt161")}
                </p>
            </div>
        </div>
    )
}